// src/services/mockData.js
// Central mock data store. Edit values here to change what appears in the UI.

// ─── Webinar Funnel ────────────────────────────────────────────────────────────
// Raw rows — shaped to match what mapBigQueryData() in useCampaignData expects

export const MOCK_CAMPAIGNS = [
  {
    event: 'WEB-2025-001',
    date: '2025-01-14',
    total_invites: 4200,
    cold_calendar: 2100,
    linkedin_invites: 1200,
    non_joiners: 600,
    expandi: 300,
    total_calls: 4200,
    total_regs: 1176,
    cal_yes: 840,
    cal_maybe: 168,
    li_event: 118,
    zoom_regs: 50,
    total_attendees: 612,
    coldcal_attendees: 405,
    nonjoiners_attendees: 115,
    linkedin_attendees: 72,
    other_attendees: 20,
    unique_viewers: 655,
    book_call_tot: 122,
    booked_call_web: 76,
    book_call_site: 24,
    book_call_sms: 10,
    book_call_set: 8,
    book_call_other: 4,
    sales: 11,
    show: 92,
    no_show: 30,
    qualified: 58,
    revenue: 154000,
  },
  {
    event: 'WEB-2025-002',
    date: '2025-01-28',
    total_invites: 3800,
    cold_calendar: 1900,
    linkedin_invites: 1050,
    non_joiners: 550,
    expandi: 300,
    total_calls: 3800,
    total_regs: 988,
    cal_yes: 700,
    cal_maybe: 148,
    li_event: 100,
    zoom_regs: 40,
    total_attendees: 504,
    coldcal_attendees: 330,
    nonjoiners_attendees: 96,
    linkedin_attendees: 60,
    other_attendees: 18,
    unique_viewers: 540,
    book_call_tot: 98,
    booked_call_web: 60,
    book_call_site: 19,
    book_call_sms: 8,
    book_call_set: 7,
    book_call_other: 4,
    sales: 9,
    show: 74,
    no_show: 24,
    qualified: 47,
    revenue: 126000,
  },
  {
    event: 'WEB-2025-003',
    date: '2025-02-11',
    total_invites: 5100,
    cold_calendar: 2600,
    linkedin_invites: 1400,
    non_joiners: 700,
    expandi: 400,
    total_calls: 5100,
    total_regs: 1479,
    cal_yes: 1040,
    cal_maybe: 222,
    li_event: 155,
    zoom_regs: 62,
    total_attendees: 769,
    coldcal_attendees: 510,
    nonjoiners_attendees: 144,
    linkedin_attendees: 90,
    other_attendees: 25,
    unique_viewers: 820,
    book_call_tot: 155,
    booked_call_web: 96,
    book_call_site: 31,
    book_call_sms: 13,
    book_call_set: 10,
    book_call_other: 5,
    sales: 14,
    show: 117,
    no_show: 38,
    qualified: 74,
    revenue: 196000,
  },
  {
    event: 'WEB-2025-004',
    date: '2025-02-25',
    total_invites: 3500,
    cold_calendar: 1750,
    linkedin_invites: 980,
    non_joiners: 480,
    expandi: 290,
    total_calls: 3500,
    total_regs: 910,
    cal_yes: 640,
    cal_maybe: 136,
    li_event: 95,
    zoom_regs: 39,
    total_attendees: 455,
    coldcal_attendees: 295,
    nonjoiners_attendees: 88,
    linkedin_attendees: 52,
    other_attendees: 20,
    unique_viewers: 490,
    book_call_tot: 88,
    booked_call_web: 54,
    book_call_site: 17,
    book_call_sms: 7,
    book_call_set: 6,
    book_call_other: 4,
    sales: 7,
    show: 66,
    no_show: 22,
    qualified: 40,
    revenue: 98000,
  },
  {
    event: 'WEB-2025-005',
    date: '2025-03-11',
    total_invites: 4600,
    cold_calendar: 2300,
    linkedin_invites: 1280,
    non_joiners: 640,
    expandi: 380,
    total_calls: 4600,
    total_regs: 1288,
    cal_yes: 920,
    cal_maybe: 193,
    li_event: 128,
    zoom_regs: 47,
    total_attendees: 670,
    coldcal_attendees: 445,
    nonjoiners_attendees: 126,
    linkedin_attendees: 74,
    other_attendees: 25,
    unique_viewers: 718,
    book_call_tot: 134,
    booked_call_web: 83,
    book_call_site: 27,
    book_call_sms: 11,
    book_call_set: 9,
    book_call_other: 4,
    sales: 12,
    show: 101,
    no_show: 33,
    qualified: 64,
    revenue: 168000,
  },
  {
    event: 'WEB-2025-006',
    date: '2025-03-25',
    total_invites: 2900,
    cold_calendar: 1450,
    linkedin_invites: 800,
    non_joiners: 400,
    expandi: 250,
    total_calls: 2900,
    total_regs: 754,
    cal_yes: 540,
    cal_maybe: 113,
    li_event: 75,
    zoom_regs: 26,
    total_attendees: 377,
    coldcal_attendees: 248,
    nonjoiners_attendees: 72,
    linkedin_attendees: 41,
    other_attendees: 16,
    unique_viewers: 403,
    book_call_tot: 74,
    booked_call_web: 46,
    book_call_site: 14,
    book_call_sms: 6,
    book_call_set: 5,
    book_call_other: 3,
    sales: 6,
    show: 56,
    no_show: 18,
    qualified: 34,
    revenue: 84000,
  },
  {
    event: 'WEB-2025-007',
    date: '2025-04-08',
    total_invites: 5400,
    cold_calendar: 2700,
    linkedin_invites: 1500,
    non_joiners: 750,
    expandi: 450,
    total_calls: 5400,
    total_regs: 1566,
    cal_yes: 1100,
    cal_maybe: 235,
    li_event: 165,
    zoom_regs: 66,
    total_attendees: 814,
    coldcal_attendees: 540,
    nonjoiners_attendees: 153,
    linkedin_attendees: 95,
    other_attendees: 26,
    unique_viewers: 870,
    book_call_tot: 163,
    booked_call_web: 101,
    book_call_site: 33,
    book_call_sms: 14,
    book_call_set: 10,
    book_call_other: 5,
    sales: 15,
    show: 123,
    no_show: 40,
    qualified: 78,
    revenue: 210000,
  },
  {
    event: 'WEB-2025-008',
    date: '2025-04-22',
    total_invites: 4100,
    cold_calendar: 2050,
    linkedin_invites: 1150,
    non_joiners: 570,
    expandi: 330,
    total_calls: 4100,
    total_regs: 1107,
    cal_yes: 780,
    cal_maybe: 166,
    li_event: 115,
    zoom_regs: 46,
    total_attendees: 576,
    coldcal_attendees: 380,
    nonjoiners_attendees: 108,
    linkedin_attendees: 66,
    other_attendees: 22,
    unique_viewers: 618,
    book_call_tot: 113,
    booked_call_web: 70,
    book_call_site: 23,
    book_call_sms: 9,
    book_call_set: 8,
    book_call_other: 3,
    sales: 10,
    show: 85,
    no_show: 28,
    qualified: 54,
    revenue: 140000,
  },
];

export const MOCK_SUMMARY = {
  total_campaigns: 8,
  total_invites: 33600,
  total_registrations: 9268,
  total_attendees: 4777,
  total_bookings: 947,
  total_sales: 84,
  total_revenue: 1176000,
  avg_invite_to_reg_rate: 27.6,
  avg_reg_to_attend_rate: 51.5,
  avg_attend_to_book_rate: 19.8,
};

// ─── Cold Calendar ─────────────────────────────────────────────────────────────
// Field names match EXACTLY what tableColumns + getFieldValue in dataUtils.js expect:
//   Title, Invite sent, Yes Responses, Maybe Responses, Confirmation conversion,
//   Zoom registrations, Attendees, Invite Conversion, Yes Conversion %,
//   Maybe Conversion %,  Bookings, Bookings conversion, Bookings per 1k invites

const pct = (n, d) => d > 0 ? ((n / d) * 100).toFixed(1) : '0';
const per1k = (n, d) => d > 0 ? ((n / d) * 1000).toFixed(1) : '0';

const makeRow = (title, invites, yes, maybe, zoomRegs, attendees, bookings) => ({
  Title:                       title,
  'Invite sent':               invites,
  'Yes Responses':             yes,
  'Maybe Responses':           maybe,
  'Confirmation conversion':   pct(yes + maybe, invites),
  'Zoom registrations':        zoomRegs,
  Attendees:                   attendees,
  'Invite Conversion':         pct(attendees, invites),
  'Yes Conversion %':          pct(attendees, yes),
  'Maybe Conversion %':        pct(attendees, maybe),
  Bookings:                    bookings,
  'Bookings conversion':       pct(bookings, attendees),
  'Bookings per 1k invites':   per1k(bookings, invites),
});

const sumRows = (rows) => {
  const t = rows.reduce((a, r) => ({
    invites:    a.invites    + (r['Invite sent']       || 0),
    yes:        a.yes        + (r['Yes Responses']     || 0),
    maybe:      a.maybe      + (r['Maybe Responses']   || 0),
    zoom:       a.zoom       + (r['Zoom registrations']|| 0),
    attendees:  a.attendees  + (r['Attendees']         || 0),
    bookings:   a.bookings   + (r['Bookings']          || 0),
  }), { invites:0, yes:0, maybe:0, zoom:0, attendees:0, bookings:0 });

  return {
    Title:                       'GRAND TOTAL',
    'Invite sent':               t.invites,
    'Yes Responses':             t.yes,
    'Maybe Responses':           t.maybe,
    'Confirmation conversion':   pct(t.yes + t.maybe, t.invites),
    'Zoom registrations':        t.zoom,
    Attendees:                   t.attendees,
    'Invite Conversion':         pct(t.attendees, t.invites),
    'Yes Conversion %':          pct(t.attendees, t.yes),
    'Maybe Conversion %':        pct(t.attendees, t.maybe),
    Bookings:                    t.bookings,
    'Bookings conversion':       pct(t.bookings, t.attendees),
    'Bookings per 1k invites':   per1k(t.bookings, t.invites),
  };
};

// ── By Title ───────────────────────────────────────────────────────────────────
//                                     invites   yes  maybe  zoom  attend  book
const TITLE_ROWS = [
  makeRow('Q4 Scaling Bootcamp v1',    8200, 1312,  574,  820,  738,   92),
  makeRow('Q4 Scaling Bootcamp v2',    7400, 1110,  518,  740,  629,   78),
  makeRow('New Year Intensive A',      6100,  854,  427,  610,  537,   66),
  makeRow('New Year Intensive B',      5800,  812,  406,  580,  498,   60),
  makeRow('Winter Strategy Series',    9300, 1395,  651,  930,  919,  112),
  makeRow('B2B Growth Masterclass',    4200,  588,  294,  420,  336,   40),
  makeRow('Spring Promo Kickoff v1',   7800, 1092,  546,  780,  741,   93),
  makeRow('Spring Promo Kickoff v2',   6400,  896,  448,  640,  576,   71),
];

export const MOCK_COLD_CALENDAR_TITLE = {
  rows: TITLE_ROWS,
  grand_total: sumRows(TITLE_ROWS),
};

// ── By Description ─────────────────────────────────────────────────────────────
const DESC_ROWS = [
  makeRow('Cold outreach — decision makers', 18400, 2944, 1288, 1840, 1564, 194),
  makeRow('Re-engagement — past attendees',  12600, 1890,  882, 1260, 1134, 138),
  makeRow('LinkedIn warm sequence',           9800, 1372,  686,  980,  882, 106),
  makeRow('Referral invite blast',            6400,  896,  448,  640,  587,  70),
  makeRow('Event reminder — 48hr',            8000, 1120,  560,  800,  693,  84),
];

export const MOCK_COLD_CALENDAR_DESCRIPTION = {
  rows: DESC_ROWS,
  grand_total: sumRows(DESC_ROWS),
};

// ── By Account ─────────────────────────────────────────────────────────────────
const ACCT_ROWS = [
  makeRow('ryan@scaletime.co',     19200, 2880, 1344, 1920, 1728, 211),
  makeRow('james@scaletime.co',    15600, 2184, 1092, 1560, 1326, 162),
  makeRow('rhino@scaletime.co',    12400, 1736,  868, 1240, 1054, 128),
  makeRow('outreach@scaletime.co',  8000, 1120,  560,  800,  691,  84),
];

export const MOCK_COLD_CALENDAR_ACCOUNT = {
  rows: ACCT_ROWS,
  grand_total: sumRows(ACCT_ROWS),
};

// ─── Filter Options ────────────────────────────────────────────────────────────

export const MOCK_FILTER_OPTIONS = {
  available_group_by_columns: ['reporting_title', 'reporting_description', 'reporting_email'],
  date_range: { min: '2025-01-01', max: '2025-04-22' },
  webinar_names: [
    'Q4 Scaling Bootcamp',
    'New Year Intensive',
    'Winter Strategy Series',
    'B2B Growth Masterclass',
    'Spring Promo Kickoff',
  ],
  clean_test_titles: [
    'Q4 Scaling Bootcamp v1',
    'Q4 Scaling Bootcamp v2',
    'New Year Intensive A',
    'New Year Intensive B',
    'Winter Strategy Series',
    'B2B Growth Masterclass',
    'Spring Promo Kickoff v1',
    'Spring Promo Kickoff v2',
  ],
  versions: ['v1', 'v2', 'A', 'B'],
  available_descriptions: [
    'Cold outreach — decision makers',
    'Re-engagement — past attendees',
    'LinkedIn warm sequence',
    'Referral invite blast',
    'Event reminder — 48hr',
  ],
  available_accounts: [
    'ryan@scaletime.co',
    'james@scaletime.co',
    'rhino@scaletime.co',
    'outreach@scaletime.co',
  ],
  available_emails: [
    'ryan@scaletime.co',
    'james@scaletime.co',
    'rhino@scaletime.co',
    'outreach@scaletime.co',
  ],
};

// ─── Timestamps ───────────────────────────────────────────────────────────────

export const MOCK_LAST_UPDATED = new Date(Date.now() - 2 * 60 * 1000).toISOString(); // 2 min ago

// ─── Configurations ───────────────────────────────────────────────────────────
// Matches the shape returned by configService.getAll():
//   { success: true, count: N, configurations: { [key]: { value, metadata, updated_at } } }
//
// Add / edit entries here to control what getConfig() and getTooltip() return
// across the entire app without touching the real API.

const ts = new Date().toISOString();

const cfg = (value, type = 'string', description = '') => ({
  value,
  metadata: { type, description, category: 'general' },
  updated_at: ts,
});

export const MOCK_CONFIGURATIONS = {
  // ── Tooltips ────────────────────────────────────────────────────────────────
  tooltip_total_leads:         cfg('Total unique contacts reached across all active campaigns.'),
  tooltip_registrations:       cfg('Contacts who completed the webinar registration form.'),
  tooltip_attended:            cfg('Registrants who joined the live session for any duration.'),
  tooltip_show_up_rate:        cfg('Attended ÷ Registered × 100. Target: ≥ 50%.'),
  tooltip_pipeline_value:      cfg('Estimated deal value from bookings generated by this campaign.'),
  tooltip_cost_per_lead:       cfg('Total ad spend ÷ total leads for the selected period.'),
  tooltip_book_to_att:         cfg('Booked calls ÷ attendees × 100.'),
  tooltip_show_to_sale:        cfg('Closed deals ÷ call shows × 100.'),

  // ── Feature flags ────────────────────────────────────────────────────────────
  feature_data_explorer:       cfg(true,  'boolean', 'Show the Campaign Explorer pivot section'),
  feature_cold_calendar:       cfg(true,  'boolean', 'Enable Cold Calendar page'),
  feature_ai_insights:         cfg(true,  'boolean', 'Show AI insight banners on dashboard'),
  feature_export_csv:          cfg(false, 'boolean', 'Enable CSV export buttons (coming soon)'),

  // ── Display settings ─────────────────────────────────────────────────────────
  dashboard_title:             cfg('Webinar Funnel', 'string', 'Page title shown in the header'),
  currency_symbol:             cfg('$',    'string', 'Currency prefix for revenue figures'),
  date_format:                 cfg('MMM D, YYYY', 'string', 'Display format for dates'),
  default_date_range:          cfg('30days', 'string', 'Default filter on load: 7days | 30days | 90days | all'),
  cache_duration_minutes:      cfg(5,     'number', 'Client-side cache TTL in minutes'),
  max_table_rows:              cfg(100,   'number', 'Maximum rows shown before pagination'),

  // ── Thresholds (used by KeyInsights colour coding) ───────────────────────────
  threshold_show_up_good:      cfg(50,    'number', 'Show-up rate % above which is green'),
  threshold_show_up_warn:      cfg(40,    'number', 'Show-up rate % below which is red'),
  threshold_cpl_good:          cfg(10,    'number', 'Cost-per-lead below which is green'),
  threshold_cpl_warn:          cfg(15,    'number', 'Cost-per-lead above which is red'),
};

export const MOCK_CONFIGURATIONS_RESPONSE = {
  success: true,
  count: Object.keys(MOCK_CONFIGURATIONS).length,
  source: 'mock',
  configurations: MOCK_CONFIGURATIONS,
};

// ─── Sales Raw Data ───────────────────────────────────────────────────────────
// Each record matches what salesService calculation methods expect:
//   opportunity_closer, deal_is_won, opportunity_value_clean, won_revenue,
//   status_category, offers_sent, appointment_date, appointment_completed_date,
//   offer_type, pipeline_stage

const CLOSERS = ['Ryan', 'James', 'Sarah', 'Mike'];
const OFFER_TYPES = ['WS25K', 'WS20K', 'MM7K', 'MM5K', 'MN3K'];
const OFFER_VALUES = { WS25K: 25000, WS20K: 20000, MM7K: 7000, MM5K: 5000, MN3K: 3000 };
const STATUSES = [
  'showed','showed','showed','showed','showed','showed', // 60%
  'no_show','no_show','no_show',                         // 20%
  'canceled','canceled',                                  // 15%
  'confirmed',                                            // 5%
];

const makeRecord = (id, closer, date, status, offerType, isWon) => {
  const value = isWon ? OFFER_VALUES[offerType] : 0;
  return {
    id,
    opportunity_closer:     closer,
    appointment_date:       date,
    appointment_completed_date: date,
    status_category:        status,
    deal_is_won:            isWon,
    opportunity_value_clean: OFFER_VALUES[offerType],
    won_revenue:            value,
    offers_sent:            status === 'showed',
    offer_type:             offerType,
    pipeline_stage:         isWon ? 'closed_won' : status === 'showed' ? 'proposal' : 'lead',
  };
};

// Generate 80 records over last 12 weeks
const genDate = (daysAgo) => {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  return d.toISOString().split('T')[0];
};

const seed = [
  // Ryan — strong closer, 28 calls
  makeRecord(1,  'Ryan', genDate(84), 'showed',   'WS25K', true),
  makeRecord(2,  'Ryan', genDate(80), 'showed',   'WS20K', true),
  makeRecord(3,  'Ryan', genDate(77), 'no_show',  'MM7K',  false),
  makeRecord(4,  'Ryan', genDate(74), 'showed',   'WS25K', true),
  makeRecord(5,  'Ryan', genDate(70), 'canceled', 'MM5K',  false),
  makeRecord(6,  'Ryan', genDate(67), 'showed',   'WS20K', false),
  makeRecord(7,  'Ryan', genDate(63), 'showed',   'WS25K', true),
  makeRecord(8,  'Ryan', genDate(60), 'no_show',  'MM7K',  false),
  makeRecord(9,  'Ryan', genDate(56), 'showed',   'WS20K', true),
  makeRecord(10, 'Ryan', genDate(53), 'showed',   'WS25K', true),
  makeRecord(11, 'Ryan', genDate(49), 'canceled', 'MN3K',  false),
  makeRecord(12, 'Ryan', genDate(46), 'showed',   'WS25K', true),
  makeRecord(13, 'Ryan', genDate(42), 'showed',   'WS20K', false),
  makeRecord(14, 'Ryan', genDate(39), 'no_show',  'MM5K',  false),
  makeRecord(15, 'Ryan', genDate(35), 'showed',   'WS25K', true),
  makeRecord(16, 'Ryan', genDate(32), 'showed',   'MM7K',  true),
  makeRecord(17, 'Ryan', genDate(28), 'canceled', 'WS20K', false),
  makeRecord(18, 'Ryan', genDate(25), 'showed',   'WS25K', true),
  makeRecord(19, 'Ryan', genDate(21), 'showed',   'WS20K', true),
  makeRecord(20, 'Ryan', genDate(18), 'no_show',  'MM7K',  false),
  makeRecord(21, 'Ryan', genDate(14), 'showed',   'WS25K', true),
  makeRecord(22, 'Ryan', genDate(11), 'showed',   'WS20K', false),
  makeRecord(23, 'Ryan', genDate(7),  'showed',   'WS25K', true),
  makeRecord(24, 'Ryan', genDate(4),  'canceled', 'MM5K',  false),
  makeRecord(25, 'Ryan', genDate(3),  'showed',   'WS25K', true),
  makeRecord(26, 'Ryan', genDate(2),  'showed',   'WS20K', true),
  makeRecord(27, 'Ryan', genDate(1),  'confirmed','WS25K', false),
  makeRecord(28, 'Ryan', genDate(0),  'showed',   'MM7K',  true),

  // James — solid mid performer, 22 calls
  makeRecord(29, 'James', genDate(82), 'showed',   'MM7K',  true),
  makeRecord(30, 'James', genDate(78), 'no_show',  'MM5K',  false),
  makeRecord(31, 'James', genDate(75), 'showed',   'WS20K', true),
  makeRecord(32, 'James', genDate(71), 'showed',   'MM7K',  false),
  makeRecord(33, 'James', genDate(68), 'canceled', 'MN3K',  false),
  makeRecord(34, 'James', genDate(64), 'showed',   'MM7K',  true),
  makeRecord(35, 'James', genDate(61), 'showed',   'WS20K', true),
  makeRecord(36, 'James', genDate(57), 'no_show',  'MM5K',  false),
  makeRecord(37, 'James', genDate(54), 'showed',   'MM7K',  false),
  makeRecord(38, 'James', genDate(50), 'showed',   'WS20K', true),
  makeRecord(39, 'James', genDate(47), 'canceled', 'MM7K',  false),
  makeRecord(40, 'James', genDate(43), 'showed',   'MM7K',  true),
  makeRecord(41, 'James', genDate(40), 'showed',   'WS20K', false),
  makeRecord(42, 'James', genDate(36), 'no_show',  'MM5K',  false),
  makeRecord(43, 'James', genDate(33), 'showed',   'MM7K',  true),
  makeRecord(44, 'James', genDate(29), 'showed',   'WS20K', true),
  makeRecord(45, 'James', genDate(26), 'showed',   'MM7K',  false),
  makeRecord(46, 'James', genDate(22), 'canceled', 'MN3K',  false),
  makeRecord(47, 'James', genDate(19), 'showed',   'MM7K',  true),
  makeRecord(48, 'James', genDate(15), 'showed',   'WS20K', true),
  makeRecord(49, 'James', genDate(8),  'no_show',  'MM5K',  false),
  makeRecord(50, 'James', genDate(2),  'showed',   'MM7K',  true),

  // Sarah — newer, fewer calls, decent conversion, 18 calls
  makeRecord(51, 'Sarah', genDate(79), 'showed',   'MM5K',  true),
  makeRecord(52, 'Sarah', genDate(72), 'no_show',  'MN3K',  false),
  makeRecord(53, 'Sarah', genDate(65), 'showed',   'MM5K',  true),
  makeRecord(54, 'Sarah', genDate(58), 'canceled', 'MM7K',  false),
  makeRecord(55, 'Sarah', genDate(51), 'showed',   'MM5K',  false),
  makeRecord(56, 'Sarah', genDate(44), 'showed',   'MM7K',  true),
  makeRecord(57, 'Sarah', genDate(37), 'no_show',  'MM5K',  false),
  makeRecord(58, 'Sarah', genDate(30), 'showed',   'MM5K',  true),
  makeRecord(59, 'Sarah', genDate(27), 'showed',   'MM7K',  false),
  makeRecord(60, 'Sarah', genDate(24), 'canceled', 'MN3K',  false),
  makeRecord(61, 'Sarah', genDate(20), 'showed',   'MM5K',  true),
  makeRecord(62, 'Sarah', genDate(16), 'showed',   'MM7K',  true),
  makeRecord(63, 'Sarah', genDate(13), 'no_show',  'MM5K',  false),
  makeRecord(64, 'Sarah', genDate(10), 'showed',   'MM5K',  true),
  makeRecord(65, 'Sarah', genDate(9),  'showed',   'MM7K',  false),
  makeRecord(66, 'Sarah', genDate(6),  'showed',   'MM5K',  true),
  makeRecord(67, 'Sarah', genDate(3),  'canceled', 'MN3K',  false),
  makeRecord(68, 'Sarah', genDate(1),  'showed',   'MM5K',  true),

  // Mike — most recent additions, 12 calls
  makeRecord(69, 'Mike', genDate(55), 'showed',   'MN3K',  true),
  makeRecord(70, 'Mike', genDate(48), 'no_show',  'MM5K',  false),
  makeRecord(71, 'Mike', genDate(41), 'showed',   'MN3K',  false),
  makeRecord(72, 'Mike', genDate(34), 'canceled', 'MM5K',  false),
  makeRecord(73, 'Mike', genDate(28), 'showed',   'MN3K',  true),
  makeRecord(74, 'Mike', genDate(23), 'showed',   'MM5K',  true),
  makeRecord(75, 'Mike', genDate(17), 'no_show',  'MN3K',  false),
  makeRecord(76, 'Mike', genDate(12), 'showed',   'MM5K',  false),
  makeRecord(77, 'Mike', genDate(9),  'showed',   'MN3K',  true),
  makeRecord(78, 'Mike', genDate(6),  'showed',   'MM5K',  true),
  makeRecord(79, 'Mike', genDate(3),  'canceled', 'MN3K',  false),
  makeRecord(80, 'Mike', genDate(1),  'showed',   'MM5K',  true),
];

export const MOCK_SALES_RAW_DATA = seed;

// ── Pre-computed KPIs (matches salesService.calculateKPIs output) ─────────────
const showed     = seed.filter(r => r.status_category === 'showed').length;
const won        = seed.filter(r => r.deal_is_won).length;
const offered    = seed.filter(r => r.offers_sent).length;
const totalValue = seed.filter(r => r.deal_is_won).reduce((s, r) => s + r.won_revenue, 0);

export const MOCK_SALES_KPI = {
  total_calls:       seed.length,
  show_rate:         Math.round((showed / seed.length) * 100),
  deals_offered:     offered,
  appointments_offered: offered,
  deals_closed:      won,
  opportunity_value: totalValue,
  conversion_rate:   Math.round((won / offered) * 100),
};

// ── Pre-computed performance data ─────────────────────────────────────────────

export const MOCK_SALES_TEAM_DATA = CLOSERS.map(name => {
  const records = seed.filter(r => r.opportunity_closer === name);
  const closerWon = records.filter(r => r.deal_is_won);
  return {
    name,
    calls:        records.length,
    appointments: records.length,
    showed:       records.filter(r => r.status_category === 'showed').length,
    no_show:      records.filter(r => r.status_category === 'no_show').length,
    deals:        closerWon.length,
    deal_value:   closerWon.reduce((s, r) => s + r.won_revenue, 0),
  };
});

export const MOCK_SALES_CALL_STATUS = {
  total:     seed.length,
  showed:    seed.filter(r => r.status_category === 'showed').length,
  no_show:   seed.filter(r => r.status_category === 'no_show').length,
  canceled:  seed.filter(r => r.status_category === 'canceled').length,
  confirmed: seed.filter(r => r.status_category === 'confirmed').length,
  closer:    'all',
};

export const MOCK_SALES_OFFERS = {
  total_sent:          offered,
  high_probability:    Math.round(offered * 0.4),
  medium_probability:  Math.round(offered * 0.35),
  low_probability:     Math.round(offered * 0.25),
  by_type: OFFER_TYPES.reduce((acc, t) => {
    acc[t] = seed.filter(r => r.offer_type === t && r.offers_sent).length;
    return acc;
  }, {}),
};

// ── Heatmap mock data ─────────────────────────────────────────────────────────

const last8Weeks = Array.from({ length: 8 }, (_, i) => {
  const d = new Date();
  d.setDate(d.getDate() - (7 - i) * 7);
  return `W${8 - i} (${d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })})`;
});

export const MOCK_SALES_HEATMAP = {
  sales_calls: {
    call_type: {
      headers: last8Weeks,
      rows: [
        { label: 'Showed',    cells: last8Weeks.map(() => ({ value: Math.floor(Math.random() * 8 + 3) })) },
        { label: 'No Show',   cells: last8Weeks.map(() => ({ value: Math.floor(Math.random() * 4 + 1) })) },
        { label: 'Canceled',  cells: last8Weeks.map(() => ({ value: Math.floor(Math.random() * 3 + 1) })) },
        { label: 'Confirmed', cells: last8Weeks.map(() => ({ value: Math.floor(Math.random() * 2) })) },
      ],
      totals: last8Weeks.map(() => Math.floor(Math.random() * 12 + 6)),
      dimension: 'call_type', tab_type: 'sales_calls',
    },
    closer: {
      headers: last8Weeks,
      rows: CLOSERS.map(name => ({
        label: name,
        cells: last8Weeks.map(() => ({ value: Math.floor(Math.random() * 6 + 1) })),
      })),
      totals: last8Weeks.map(() => Math.floor(Math.random() * 12 + 6)),
      dimension: 'closer', tab_type: 'sales_calls',
    },
  },
  offers_sent: {
    offer_type: {
      headers: last8Weeks,
      rows: OFFER_TYPES.map(t => ({
        label: t,
        cells: last8Weeks.map(() => ({ value: Math.floor(Math.random() * 4) })),
      })),
      totals: last8Weeks.map(() => Math.floor(Math.random() * 8 + 2)),
      dimension: 'offer_type', tab_type: 'offers_sent',
    },
    probability: {
      headers: last8Weeks,
      rows: [
        { label: 'High',   cells: last8Weeks.map(() => ({ value: Math.floor(Math.random() * 4 + 1) })) },
        { label: 'Medium', cells: last8Weeks.map(() => ({ value: Math.floor(Math.random() * 3 + 1) })) },
        { label: 'Low',    cells: last8Weeks.map(() => ({ value: Math.floor(Math.random() * 2) })) },
      ],
      totals: last8Weeks.map(() => Math.floor(Math.random() * 8 + 2)),
      dimension: 'probability', tab_type: 'offers_sent',
    },
  },
  closed_deals: {
    person: {
      headers: last8Weeks,
      rows: CLOSERS.map(name => ({
        label: name,
        cells: last8Weeks.map(() => ({ value: Math.floor(Math.random() * 3) })),
      })),
      totals: last8Weeks.map(() => Math.floor(Math.random() * 5 + 1)),
      dimension: 'person', tab_type: 'closed_deals',
    },
    offer_type: {
      headers: last8Weeks,
      rows: OFFER_TYPES.map(t => ({
        label: t,
        cells: last8Weeks.map(() => ({ value: Math.floor(Math.random() * 2) })),
      })),
      totals: last8Weeks.map(() => Math.floor(Math.random() * 5 + 1)),
      dimension: 'offer_type', tab_type: 'closed_deals',
    },
  },
};

export const MOCK_SALES_FILTER_OPTIONS = {
  closers:        ['all', ...CLOSERS],
  offer_types:    ['all', ...OFFER_TYPES],
  statuses:       ['all', 'showed', 'no_show', 'canceled', 'confirmed'],
  pipeline_stages:['all', 'lead', 'proposal', 'closed_won'],
};

// ─── Bid Template ─────────────────────────────────────────────────────────────
// MOCK_BID_SCENARIOS  — shape matches SavedScenarioTab ScenarioCard props
// MOCK_BID_ENGAGEMENTS — shape matches useWonEngagements response
// MOCK_BID_COMPONENTS  — actual hours per engagement (keyed by engagement id)

// ── Saved scenarios ────────────────────────────────────────────────────────────
export const MOCK_BID_SCENARIOS = {
  scenarios: [
    {
      id: 'scen-001',
      name: 'Pinnacle Law - Full Retainer',
      client_name: 'Whitfield & Partners',
      engagement_type: 'retainer',
      bid_value: 18500,
      min_bid: 16500,
      max_bid: 21000,
      total_hours: 112,
      total_cost: 10360,
      margin: 44.0,
      notes: 'Strong fit with past tech law retainer. Includes SEO, content, and PR.',
      selected_template: { id: 'eng-001', engagement_name: 'Vantage Legal - Retainer 2023' },
      selected_baseline: null,
      rate_overrides: { 'Sr AM': 185 },
      services: [],
      updated_at: new Date(Date.now() - 2 * 864e5).toISOString(),
    },
    {
      id: 'scen-002',
      name: 'Westlake Capital - Project',
      client_name: 'Crestwood Capital Group',
      engagement_type: 'project',
      bid_value: 42000,
      min_bid: 38000,
      max_bid: 47000,
      total_hours: 240,
      total_cost: 25200,
      margin: 40.0,
      notes: 'Website redesign + brand refresh. Scoped from Lakeview Capital project.',
      selected_template: { id: 'eng-002', engagement_name: 'Elevation Capital - Brand Launch' },
      selected_baseline: null,
      rate_overrides: {},
      services: [],
      updated_at: new Date(Date.now() - 5 * 864e5).toISOString(),
    },
    {
      id: 'scen-003',
      name: 'Clearview Health - Monthly Retainer',
      client_name: 'Lumina Health Systems',
      engagement_type: 'retainer',
      bid_value: 9800,
      min_bid: 8500,
      max_bid: 11000,
      total_hours: 68,
      total_cost: 6076,
      margin: 38.0,
      notes: null,
      selected_template: null,
      selected_baseline: { id: 'baseline-medium', label: 'Medium Client' },
      rate_overrides: {},
      services: [],
      updated_at: new Date(Date.now() - 10 * 864e5).toISOString(),
    },
    {
      id: 'scen-004',
      name: 'Axiom Tech - PR & Content',
      client_name: 'Prism Digital Inc.',
      engagement_type: 'retainer',
      bid_value: 14200,
      min_bid: 12500,
      max_bid: 16000,
      total_hours: 88,
      total_cost: 8008,
      margin: 43.6,
      notes: 'Focus on thought leadership and media relations.',
      selected_template: { id: 'eng-003', engagement_name: 'Apex Digital - PR Retainer 2024' },
      selected_baseline: null,
      rate_overrides: { 'Principal': 295 },
      services: [],
      updated_at: new Date(Date.now() - 14 * 864e5).toISOString(),
    },
    {
      id: 'scen-005',
      name: 'Highpoint Realty - Launch Campaign',
      client_name: 'Highpoint Property Group',
      engagement_type: 'project',
      bid_value: 28500,
      min_bid: 25000,
      max_bid: 32000,
      total_hours: 160,
      total_cost: 18240,
      margin: 36.0,
      notes: 'New development launch — digital, social, and print.',
      selected_template: null,
      selected_baseline: { id: 'baseline-high', label: 'High Complexity' },
      rate_overrides: {},
      services: [],
      updated_at: new Date(Date.now() - 18 * 864e5).toISOString(),
    },
    {
      id: 'scen-006',
      name: 'Ridgeline Medical - SEO Only',
      client_name: 'Meadowbrook Medical',
      engagement_type: 'retainer',
      bid_value: 5500,
      min_bid: 4800,
      max_bid: 6200,
      total_hours: 38,
      total_cost: 2926,
      margin: 46.8,
      notes: 'Stripped-down SEO retainer. Built from scratch.',
      selected_template: null,
      selected_baseline: null,
      rate_overrides: {},
      services: [],
      updated_at: new Date(Date.now() - 22 * 864e5).toISOString(),
    },
    {
      id: 'scen-007',
      name: 'Bridgeport Advisors - Full Service',
      client_name: 'Lakeside Financial Group',
      engagement_type: 'retainer',
      bid_value: 32000,
      min_bid: 28000,
      max_bid: 36000,
      total_hours: 175,
      total_cost: 17500,
      margin: 45.3,
      notes: 'Large retainer — PR, content, social, email, and paid. Used Pinnacle Law actuals as reference.',
      selected_template: { id: 'eng-001', engagement_name: 'Vantage Legal - Retainer 2023' },
      selected_baseline: null,
      rate_overrides: { 'Principal': 310, 'Sr AM': 190 },
      services: [],
      updated_at: new Date(Date.now() - 30 * 864e5).toISOString(),
    },
    {
      id: 'scen-008',
      name: 'Northgate Ventures - Brand Identity',
      client_name: 'Northgate Ventures',
      engagement_type: 'project',
      bid_value: 15750,
      min_bid: 14000,
      max_bid: 18000,
      total_hours: 95,
      total_cost: 10450,
      margin: 33.7,
      notes: null,
      selected_template: null,
      selected_baseline: { id: 'baseline-model', label: 'Model Client' },
      rate_overrides: {},
      services: [],
      updated_at: new Date(Date.now() - 45 * 864e5).toISOString(),
    },
  ],
  total: 8,
};

// ── Won engagements (Path A reference list) ────────────────────────────────────
export const MOCK_BID_ENGAGEMENTS = {
  engagements: [
    {
      id: 'eng-001',
      engagement_name: 'Vantage Legal - Retainer 2023',
      qb_customer_name: 'Vantage Legal Partners',
      qb_customer_ref: 'QB-4421',
      engagement_type: 'Retainer',
      bid_status: 'Won',
      industry: 'Legal',
      practice_area: 'PR & Content',
      start_date: '2023-01-15',
      end_date: '2023-12-31',
      estimated_value: 198000,
      estimated_hours: 1320,
      scope_summary: 'Full-service retainer: PR, content marketing, SEO, and social media',
      tags: ['PR', 'Content', 'SEO', 'Legal'],
      lessons_learned: 'Strong ROI on thought leadership content',
    },
    {
      id: 'eng-002',
      engagement_name: 'Elevation Capital - Brand Launch',
      qb_customer_name: 'Elevation Capital Partners',
      qb_customer_ref: 'QB-3387',
      engagement_type: 'Project',
      bid_status: 'Won',
      industry: 'Finance',
      practice_area: 'Branding',
      start_date: '2023-03-01',
      end_date: '2023-06-30',
      estimated_value: 44000,
      estimated_hours: 260,
      scope_summary: 'Brand identity refresh, website redesign, and launch campaign',
      tags: ['Branding', 'Web', 'Launch'],
      lessons_learned: 'Scope creep on website — add 15% buffer for finance clients',
    },
    {
      id: 'eng-003',
      engagement_name: 'Apex Digital - PR Retainer 2024',
      qb_customer_name: 'Apex Digital Inc.',
      qb_customer_ref: 'QB-5102',
      engagement_type: 'Retainer',
      bid_status: 'Won',
      industry: 'Technology',
      practice_area: 'PR & Media',
      start_date: '2024-01-01',
      end_date: '2024-12-31',
      estimated_value: 156000,
      estimated_hours: 1040,
      scope_summary: 'Thought leadership, media relations, and executive visibility',
      tags: ['PR', 'Media', 'Tech', 'Executive'],
      lessons_learned: null,
    },
    {
      id: 'eng-004',
      engagement_name: 'Harborside Dental - Local SEO',
      qb_customer_name: 'Harborside Dental Group',
      qb_customer_ref: 'QB-2891',
      engagement_type: 'Retainer',
      bid_status: 'Won',
      industry: 'Healthcare',
      practice_area: 'SEO',
      start_date: '2023-06-01',
      end_date: '2024-05-31',
      estimated_value: 72000,
      estimated_hours: 480,
      scope_summary: 'Local SEO, Google Business, and monthly reporting for 4 locations',
      tags: ['SEO', 'Local', 'Healthcare'],
      lessons_learned: 'Multi-location tracking adds ~10% hours',
    },
    {
      id: 'eng-005',
      engagement_name: 'Highpoint Realty - Launch Campaign',
      qb_customer_name: 'Highpoint Realty Holdings',
      qb_customer_ref: 'QB-4768',
      engagement_type: 'Project',
      bid_status: 'Won',
      industry: 'Real Estate',
      practice_area: 'Campaign',
      start_date: '2023-08-01',
      end_date: '2023-11-30',
      estimated_value: 31000,
      estimated_hours: 180,
      scope_summary: 'New development launch — digital ads, social, email drip, and PR',
      tags: ['Campaign', 'Social', 'Paid', 'Real Estate'],
      lessons_learned: null,
    },
    {
      id: 'eng-006',
      engagement_name: 'ClearShield Insurance - Content Program',
      qb_customer_name: 'ClearShield Insurance Solutions',
      qb_customer_ref: 'QB-3654',
      engagement_type: 'Retainer',
      bid_status: 'Won',
      industry: 'Insurance',
      practice_area: 'Content Marketing',
      start_date: '2023-09-01',
      end_date: '2024-08-31',
      estimated_value: 108000,
      estimated_hours: 720,
      scope_summary: 'Blog content, email newsletter, whitepapers, and LinkedIn strategy',
      tags: ['Content', 'Email', 'LinkedIn', 'Finance'],
      lessons_learned: 'Compliance review adds 1–2 weeks per deliverable',
    },
    {
      id: 'eng-007',
      engagement_name: 'Brightfield Academy - Rebrand',
      qb_customer_name: 'Brightfield Academy',
      qb_customer_ref: 'QB-6023',
      engagement_type: 'Project',
      bid_status: 'Won',
      industry: 'Education',
      practice_area: 'Branding',
      start_date: '2024-02-01',
      end_date: '2024-05-31',
      estimated_value: 38500,
      estimated_hours: 220,
      scope_summary: 'Full rebrand: identity, messaging framework, website, and brand guide',
      tags: ['Branding', 'Web', 'Education'],
      lessons_learned: 'Stakeholder approval rounds took longer than expected',
    },
    {
      id: 'eng-008',
      engagement_name: 'Steelmark Industries - Digital',
      qb_customer_name: 'Steelmark Industries Co.',
      qb_customer_ref: 'QB-2244',
      engagement_type: 'Retainer',
      bid_status: 'Won',
      industry: 'Manufacturing',
      practice_area: 'Digital Marketing',
      start_date: '2024-03-01',
      end_date: '2025-02-28',
      estimated_value: 84000,
      estimated_hours: 560,
      scope_summary: 'B2B digital marketing — LinkedIn, trade content, paid search, and email',
      tags: ['B2B', 'LinkedIn', 'Paid', 'Manufacturing'],
      lessons_learned: null,
    },
    {
      id: 'eng-009',
      engagement_name: 'Solace Wellness - Social & PR',
      qb_customer_name: 'Solace Wellness Centers',
      qb_customer_ref: 'QB-5571',
      engagement_type: 'Retainer',
      bid_status: 'Won',
      industry: 'Healthcare',
      practice_area: 'Social Media',
      start_date: '2023-11-01',
      end_date: '2024-10-31',
      estimated_value: 96000,
      estimated_hours: 640,
      scope_summary: 'Instagram/Facebook management, influencer partnerships, and local PR',
      tags: ['Social', 'PR', 'Healthcare', 'Influencer'],
      lessons_learned: 'Photography coordination adds ~8h/month',
    },
    {
      id: 'eng-010',
      engagement_name: 'Vertex Legal - Thought Leadership',
      qb_customer_name: 'Vertex Legal Group',
      qb_customer_ref: 'QB-7819',
      engagement_type: 'Retainer',
      bid_status: 'Won',
      industry: 'Legal',
      practice_area: 'PR & Content',
      start_date: '2024-01-15',
      end_date: '2024-12-31',
      estimated_value: 132000,
      estimated_hours: 880,
      scope_summary: 'Attorney thought leadership: bylines, speaking opps, LinkedIn, and media',
      tags: ['PR', 'Content', 'Legal', 'Executive'],
      lessons_learned: null,
    },
  ],
  total: 10,
};

// ── Engagement components (actual hours — keyed by engagement id) ───────────────
// Shape mirrors useBidEngagementComponents response:
//   { components: [{ month, employee_name, employee_rate, rank, product_service, hours }] }
export const MOCK_BID_COMPONENTS = {
  'eng-001': {
    components: [
      // Jan 2023
      { month: '2023-01', employee_name: 'Alex K.',   employee_rate: 185, rank: 'Sr AM',         product_service: 'Public Relations',   hours: 28 },
      { month: '2023-01', employee_name: 'Jordan T.',  employee_rate: 110, rank: 'Acct Mgr',       product_service: 'Content Marketing',  hours: 22 },
      { month: '2023-01', employee_name: 'Casey N.',   employee_rate: 65,  rank: 'Asst Acct Mgr',  product_service: 'SEO',                hours: 18 },
      { month: '2023-01', employee_name: 'Riley L.',   employee_rate: 50,  rank: 'Mktg Support',   product_service: 'Social Media',       hours: 14 },
      // Feb 2023
      { month: '2023-02', employee_name: 'Alex K.',   employee_rate: 185, rank: 'Sr AM',         product_service: 'Public Relations',   hours: 30 },
      { month: '2023-02', employee_name: 'Jordan T.',  employee_rate: 110, rank: 'Acct Mgr',       product_service: 'Content Marketing',  hours: 20 },
      { month: '2023-02', employee_name: 'Casey N.',   employee_rate: 65,  rank: 'Asst Acct Mgr',  product_service: 'SEO',                hours: 20 },
      { month: '2023-02', employee_name: 'Riley L.',   employee_rate: 50,  rank: 'Mktg Support',   product_service: 'Social Media',       hours: 12 },
      // Mar 2023
      { month: '2023-03', employee_name: 'Alex K.',   employee_rate: 185, rank: 'Sr AM',         product_service: 'Public Relations',   hours: 26 },
      { month: '2023-03', employee_name: 'Jordan T.',  employee_rate: 110, rank: 'Acct Mgr',       product_service: 'Content Marketing',  hours: 24 },
      { month: '2023-03', employee_name: 'Casey N.',   employee_rate: 65,  rank: 'Asst Acct Mgr',  product_service: 'SEO',                hours: 16 },
      { month: '2023-03', employee_name: 'Riley L.',   employee_rate: 50,  rank: 'Mktg Support',   product_service: 'Social Media',       hours: 16 },
    ],
  },
  'eng-002': {
    components: [
      { month: '2023-03', employee_name: 'Morgan R.',   employee_rate: 265, rank: 'Principal',      product_service: 'Branding',           hours: 20 },
      { month: '2023-03', employee_name: 'Alex K.',   employee_rate: 185, rank: 'Sr AM',          product_service: 'Branding',           hours: 32 },
      { month: '2023-03', employee_name: 'Jordan T.',  employee_rate: 110, rank: 'Acct Mgr',       product_service: 'Web Design',         hours: 40 },
      { month: '2023-03', employee_name: 'Casey N.',   employee_rate: 65,  rank: 'Asst Acct Mgr',  product_service: 'Web Design',         hours: 30 },
      { month: '2023-04', employee_name: 'Morgan R.',   employee_rate: 265, rank: 'Principal',      product_service: 'Branding',           hours: 12 },
      { month: '2023-04', employee_name: 'Alex K.',   employee_rate: 185, rank: 'Sr AM',          product_service: 'Branding',           hours: 28 },
      { month: '2023-04', employee_name: 'Jordan T.',  employee_rate: 110, rank: 'Acct Mgr',       product_service: 'Web Design',         hours: 44 },
      { month: '2023-04', employee_name: 'Casey N.',   employee_rate: 65,  rank: 'Asst Acct Mgr',  product_service: 'Web Design',         hours: 36 },
    ],
  },
  'eng-003': {
    components: [
      { month: '2024-01', employee_name: 'Morgan R.',   employee_rate: 265, rank: 'Principal',      product_service: 'Public Relations',   hours: 16 },
      { month: '2024-01', employee_name: 'Alex K.',   employee_rate: 185, rank: 'Sr AM',          product_service: 'Public Relations',   hours: 32 },
      { month: '2024-01', employee_name: 'Sam M.',    employee_rate: 110, rank: 'Acct Mgr',       product_service: 'Content Marketing',  hours: 24 },
      { month: '2024-01', employee_name: 'Riley L.',   employee_rate: 50,  rank: 'Mktg Support',   product_service: 'Social Media',       hours: 14 },
      { month: '2024-02', employee_name: 'Morgan R.',   employee_rate: 265, rank: 'Principal',      product_service: 'Public Relations',   hours: 14 },
      { month: '2024-02', employee_name: 'Alex K.',   employee_rate: 185, rank: 'Sr AM',          product_service: 'Public Relations',   hours: 30 },
      { month: '2024-02', employee_name: 'Sam M.',    employee_rate: 110, rank: 'Acct Mgr',       product_service: 'Content Marketing',  hours: 26 },
      { month: '2024-02', employee_name: 'Riley L.',   employee_rate: 50,  rank: 'Mktg Support',   product_service: 'Social Media',       hours: 16 },
    ],
  },
};

// ─── Bid Documents ────────────────────────────────────────────────────────────
// Shape matches what DocumentManagementTab + useDocuments expect.
// extraction_status: 'success' | 'partial' | null (= uploaded, not yet extracted)
// ExtractionResultModal reads: result.extraction / result.extraction_result.extraction

export const MOCK_BID_DOCUMENTS = [
  {
    id: 'doc-001',
    original_name: 'Pinnacle_Law_Group_Proposal_2024.pdf',
    display_name: 'Whitfield & Partners — Full Retainer Proposal',
    type: 'application/pdf',
    size: 1024 * 420,
    uploaded_at: new Date(Date.now() - 3 * 864e5).toISOString(),
    category: 'Proposal',
    bid_status: 'Won',
    engagement_type: 'Retainer',
    engagement_id: 'eng-001',
    engagement_name: 'Vantage Legal - Retainer 2023',
    client_name: 'Whitfield & Partners',
    bid_amount: 18500,
    extraction_status: 'success',
    confidence_score: 0.91,
    extracted_tags: ['PR', 'Content', 'Legal', 'Retainer', 'High Priority'],
    extracted_at: new Date(Date.now() - 3 * 864e5 + 60000).toISOString(),
    was_re_extracted: false,
    tags: ['High Priority'],
  },
  {
    id: 'doc-002',
    original_name: 'Westlake_Capital_Brand_Refresh_RFP.pdf',
    display_name: 'Westlake Capital — Brand Refresh RFP',
    type: 'application/pdf',
    size: 1024 * 680,
    uploaded_at: new Date(Date.now() - 6 * 864e5).toISOString(),
    category: 'RFP',
    bid_status: 'In Progress',
    engagement_type: 'Project',
    engagement_id: null,
    engagement_name: null,
    client_name: 'Crestwood Capital Group',
    bid_amount: 42000,
    extraction_status: 'success',
    confidence_score: 0.85,
    extracted_tags: ['Branding', 'Web', 'Finance', 'Project'],
    extracted_at: new Date(Date.now() - 6 * 864e5 + 90000).toISOString(),
    was_re_extracted: true,
    tags: ['Finance Review'],
  },
  {
    id: 'doc-003',
    original_name: 'Axiom_Tech_PR_Scope.pdf',
    display_name: 'Prism Digital Inc. — PR Scope Document',
    type: 'application/pdf',
    size: 1024 * 215,
    uploaded_at: new Date(Date.now() - 10 * 864e5).toISOString(),
    category: 'Proposal',
    bid_status: 'Submitted',
    engagement_type: 'Retainer',
    engagement_id: 'eng-003',
    engagement_name: 'Apex Digital - PR Retainer 2024',
    client_name: 'Prism Digital Inc.',
    bid_amount: 14200,
    extraction_status: 'partial',
    confidence_score: 0.61,
    extracted_tags: ['PR', 'Tech', 'Media'],
    extracted_at: new Date(Date.now() - 10 * 864e5 + 45000).toISOString(),
    was_re_extracted: false,
    tags: ['Needs Follow-up'],
  },
  {
    id: 'doc-004',
    original_name: 'Summit_Realty_Launch_Brief.pdf',
    display_name: 'Summit Realty — Launch Campaign Brief',
    type: 'application/pdf',
    size: 1024 * 340,
    uploaded_at: new Date(Date.now() - 14 * 864e5).toISOString(),
    category: 'Reference',
    bid_status: 'Pending',
    engagement_type: 'Project',
    engagement_id: null,
    engagement_name: null,
    client_name: null,
    bid_amount: null,
    extraction_status: null,  // not yet extracted
    confidence_score: null,
    extracted_tags: [],
    extracted_at: null,
    was_re_extracted: false,
    tags: [],
  },
  {
    id: 'doc-005',
    original_name: 'Berbay_Service_Template_2024.docx',
    display_name: 'Berbay Service Agreement Template 2024',
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    size: 1024 * 88,
    uploaded_at: new Date(Date.now() - 20 * 864e5).toISOString(),
    category: 'Template',
    bid_status: 'Pending',
    engagement_type: 'Retainer',
    engagement_id: null,
    engagement_name: null,
    client_name: null,
    bid_amount: null,
    extraction_status: null,  // word doc — no extraction
    confidence_score: null,
    extracted_tags: [],
    extracted_at: null,
    was_re_extracted: false,
    tags: ['Archived'],
  },
  {
    id: 'doc-006',
    original_name: 'Bridgeport_Advisors_Full_Service_Proposal.pdf',
    display_name: 'Bridgeport Financial — Full Service Proposal',
    type: 'application/pdf',
    size: 1024 * 512,
    uploaded_at: new Date(Date.now() - 28 * 864e5).toISOString(),
    category: 'Proposal',
    bid_status: 'Won',
    engagement_type: 'Retainer',
    engagement_id: 'eng-001',
    engagement_name: 'Vantage Legal - Retainer 2023',
    client_name: 'Lakeside Financial Group',
    bid_amount: 32000,
    extraction_status: 'success',
    confidence_score: 0.94,
    extracted_tags: ['PR', 'Content', 'Social', 'Email', 'Paid', 'Finance'],
    extracted_at: new Date(Date.now() - 28 * 864e5 + 120000).toISOString(),
    was_re_extracted: false,
    tags: ['High Priority'],
  },
];

// ── Extraction results keyed by doc id ────────────────────────────────────────
// Shape mirrors what documentsApi.getExtractionResult returns and what
// ExtractionResultModal reads: result.extraction / result.extraction_result.extraction

export const MOCK_BID_EXTRACTION_RESULTS = {
  'doc-001': {
    status: 'success',
    confidence_score: 0.91,
    extraction: {
      client_name:       'Whitfield & Partners',
      engagement_type:   'Retainer',
      total_fee:         18500,
      monthly_fee:       18500,
      scope_summary:     'Full-service retainer including PR, content marketing, SEO, and social media management. Monthly reporting and strategy calls included.',
      services:          ['Public Relations', 'Content Marketing', 'SEO', 'Social Media'],
      term_months:       12,
      start_date:        '2024-02-01',
      industry:          'Legal',
      decision_criteria: 'Experience with law firms, thought leadership capability, LA market presence',
    },
    tags: { tags: ['PR', 'Content', 'Legal', 'Retainer', 'High Priority'] },
  },
  'doc-002': {
    status: 'success',
    confidence_score: 0.85,
    extraction: {
      client_name:       'Crestwood Capital Group',
      engagement_type:   'Project',
      total_fee:         42000,
      monthly_fee:       null,
      scope_summary:     'Brand identity refresh and website redesign. Includes new logo, brand guide, 8-page website, and 3-month launch campaign.',
      services:          ['Branding', 'Web Design', 'Campaign'],
      term_months:       4,
      start_date:        '2024-03-15',
      industry:          'Finance',
      decision_criteria: 'Modern brand aesthetic, financial services experience, fast turnaround',
    },
    tags: { tags: ['Branding', 'Web', 'Finance', 'Project'] },
  },
  'doc-003': {
    status: 'partial',
    confidence_score: 0.61,
    extraction: {
      client_name:       'Prism Digital Inc.',
      engagement_type:   'Retainer',
      total_fee:         null,   // could not extract — partial
      monthly_fee:       14200,
      scope_summary:     'PR and media relations retainer. Thought leadership, executive visibility, and earned media. Fee range mentioned but not confirmed.',
      services:          ['Public Relations', 'Media Relations'],
      term_months:       null,
      start_date:        null,
      industry:          'Technology',
      decision_criteria: null,
    },
    tags: { tags: ['PR', 'Tech', 'Media'] },
  },
  'doc-006': {
    status: 'success',
    confidence_score: 0.94,
    extraction: {
      client_name:       'Lakeside Financial Group',
      engagement_type:   'Retainer',
      total_fee:         32000,
      monthly_fee:       32000,
      scope_summary:     'Comprehensive retainer covering PR, content, social media, email marketing, and paid digital. Monthly strategy sessions and quarterly reviews.',
      services:          ['Public Relations', 'Content Marketing', 'Social Media', 'Email Marketing', 'Paid Digital'],
      term_months:       12,
      start_date:        '2024-01-01',
      industry:          'Finance',
      decision_criteria: 'Full-service capability, financial services expertise, strong PR network',
    },
    tags: { tags: ['PR', 'Content', 'Social', 'Email', 'Paid', 'Finance'] },
  },
};

// ─── Employee Rates (for useRoleRateMap in Step4BuildServices) ────────────────
// Shape matches what useEmployeeRates returns: array of { rank, rate, active_status }

export const MOCK_EMPLOYEE_RATES = [
  { qb_employee_id: 'emp-001', employee: 'Jamie R.',  rank: 'Principal',     rate: 265, type: 'Employee', active_status: true },
  { qb_employee_id: 'emp-002', employee: 'Sarah K.',  rank: 'Sr AM',         rate: 185, type: 'Employee', active_status: true },
  { qb_employee_id: 'emp-003', employee: 'Alex M.',   rank: 'Sr AM',         rate: 180, type: 'Employee', active_status: true },
  { qb_employee_id: 'emp-004', employee: 'Marcus T.', rank: 'Acct Mgr',      rate: 110, type: 'Employee', active_status: true },
  { qb_employee_id: 'emp-005', employee: 'Casey N.',  rank: 'Acct Mgr',      rate: 105, type: 'Employee', active_status: true },
  { qb_employee_id: 'emp-006', employee: 'Priya N.',  rank: 'Asst Acct Mgr', rate: 65,  type: 'Employee', active_status: true },
  { qb_employee_id: 'emp-007', employee: 'Riley L.',  rank: 'Asst Acct Mgr', rate: 62,  type: 'Employee', active_status: true },
  { qb_employee_id: 'emp-008', employee: 'Derek L.',  rank: 'Mktg Support',  rate: 50,  type: 'Employee', active_status: true },
  { qb_employee_id: 'emp-009', employee: 'Morgan R.', rank: 'Mktg Support',  rate: 50,  type: 'Employee', active_status: true },
];

// ─── Mock Bookings (for BookingsModal in CampaignPerformance) ────────────────
// Keyed by event ID. Each entry is an array of booking records.

const FIRST_NAMES = ['James','Maria','David','Sarah','Michael','Jennifer','Robert','Linda','William','Elizabeth','John','Patricia','Richard','Barbara','Thomas','Susan','Chris','Jessica','Daniel','Karen','Matthew','Nancy','Anthony','Lisa','Mark','Betty','Steven','Dorothy','Paul','Sandra','Andrew','Ashley','Joshua','Kimberly','Kenneth','Emily','Kevin','Donna','Brian','Michelle','George','Carol','Timothy','Amanda','Ronald','Melissa','Edward','Deborah','Jason','Stephanie'];
const LAST_NAMES = ['Smith','Johnson','Williams','Brown','Jones','Garcia','Miller','Davis','Rodriguez','Martinez','Hernandez','Lopez','Gonzalez','Wilson','Anderson','Thomas','Taylor','Moore','Jackson','Martin','Lee','Perez','Thompson','White','Harris','Sanchez','Clark','Ramirez','Lewis','Robinson','Walker','Young','Allen','King','Wright','Scott','Torres','Nguyen','Hill','Flores'];
const DOMAINS = ['gmail.com','yahoo.com','outlook.com','hotmail.com','company.co','bizmail.com','protonmail.com'];

const generateMockBookings = (eventId, count) => {
  const rng = (max) => Math.floor(Math.random() * max);
  return Array.from({ length: count }, (_, i) => {
    const first = FIRST_NAMES[rng(FIRST_NAMES.length)];
    const last = LAST_NAMES[rng(LAST_NAMES.length)];
    const domain = DOMAINS[rng(DOMAINS.length)];
    return {
      contact_id: `cid_${eventId.replace(/[^a-zA-Z0-9]/g, '')}_${String(i + 1).padStart(3, '0')}`,
      email: `${first.toLowerCase()}.${last.toLowerCase()}${rng(99)}@${domain}`,
      first_name: first,
      last_name: last,
      phone: `+1${String(2000000000 + rng(8000000000))}`,
      was_invited: Math.random() < 0.65 ? 1 : 0,
      booking_source: ['webinar', 'website', 'email_sms', 'other'][rng(4)],
      booked_at: new Date(2025, rng(6), 1 + rng(28)).toISOString(),
    };
  });
};

// Pre-generate so the data is stable within a session
// Counts match book_call_tot from MOCK_CAMPAIGNS
export const MOCK_BOOKINGS = {
  'WEB-2025-001': generateMockBookings('WEB-2025-001', 122),
  'WEB-2025-002': generateMockBookings('WEB-2025-002', 98),
  'WEB-2025-003': generateMockBookings('WEB-2025-003', 155),
  'WEB-2025-004': generateMockBookings('WEB-2025-004', 88),
  'WEB-2025-005': generateMockBookings('WEB-2025-005', 134),
  'WEB-2025-006': generateMockBookings('WEB-2025-006', 74),
  'WEB-2025-007': generateMockBookings('WEB-2025-007', 163),
  'WEB-2025-008': generateMockBookings('WEB-2025-008', 113),
};